import { Typography } from '@material-ui/core';
import { Link as RRLink } from 'react-router-dom';
import Breadcrumb from '../Breadcrumb';
import DocumentAccessControl1 from './../../assets/DocumentAccessControl-1.png';
import HelpFooter from './HelpFooter';
import useStyles from './useStyles';
import { useTranslation } from 'react-i18next';

export default function DocumentAccessControl() {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <div className={classes.root}>
      <Breadcrumb
        name="topicName"
        data={{
          helpTopic: t('help.topics.permissions.label'),
          helpTopicId: 'permissions',
          topicName: t('help.subtopics.documentAccessControl'),
          topicNameId: 'document-access-control'
        }}
      />
      <Typography className={classes.title} component="p" variant="h4">
        {t('help.pages.documentAccessControl.title')}
      </Typography>
      <Typography variant="body1" gutterBottom>
        {t('help.pages.documentAccessControl.description')}{' '}
        <RRLink to="/helps/permissions/user-access-control">
          {t('help.subtopics.userAccessControl')}
        </RRLink>{' '}
      </Typography>
      <Typography className={classes.textLeftMargin} variant="body2">
        <u>{t('help.documentAccessControlLevel')}</u>
      </Typography>
      <Typography className={classes.textLeftMargin} variant="body2">
        - {t('help.levels.highlyConfidential')}
      </Typography>
      <Typography className={classes.textLeftMargin} variant="body2">
        - {t('help.levels.confidential')}
      </Typography>
      <Typography className={classes.textLeftMargin} variant="body2">
        - {t('help.levels.internal')}
      </Typography>
      <Typography className={classes.textLeftMargin} variant="body2">
        - {t('help.levels.external')}
      </Typography>
      <Typography className={classes.textLeftMargin} variant="body2">
        - {t('help.levels.public')}
      </Typography>
      <img
        className={classes.media}
        src={DocumentAccessControl1}
        alt={`${String(t('help.stepAltPrefix'))}1`}
      />
      <HelpFooter />
    </div>
  );
}
